// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

// Components
import './components'

// Plugins
import './plugins'

// Sync router with store
import { sync } from 'vuex-router-sync'

// Application imports
import App from './App'
import i18n from '@/i18n'
import router from '@/router'
import store from '@/store'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import ApiService from '@/services/api.service.js'
import { TokenService } from './services/storage.service'
import IdleVue from 'idle-vue'
import moment from 'moment'
import VeeValidate from 'vee-validate'
import './../node_modules/dropzone/dist/dropzone.css'
import { Can } from '@casl/vue'

import vBlur from 'v-blur'
Vue.use(vBlur)

require('dotenv').config()

// Sync store with router
sync(store, router)

window.moment = moment

const eventsHub = new Vue()

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: process.env.VUE_APP_TIMEOUT_MS
})
Vue.config.productionTip = false

Vue.use(VeeValidate)

ApiService.init(process.env.VUE_APP_ACCINVENTORY_API)
if (TokenService.getToken()) {
  ApiService.setHeader()
}

Vue.component('Can', Can)

/* eslint-disable no-new */
window.vm = new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
